import { render, staticRenderFns } from "./CreateDetailedSuppliesModal.vue?vue&type=template&id=1ce85fd8"
import script from "./CreateDetailedSuppliesModal.vue?vue&type=script&lang=js"
export * from "./CreateDetailedSuppliesModal.vue?vue&type=script&lang=js"
import style0 from "./CreateDetailedSuppliesModal.vue?vue&type=style&index=0&id=1ce85fd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports